
import { useEffect } from 'react';

const IndianAutoTranslate = () => {
  useEffect(() => {
    const autoTranslate = async () => {
      // Check if user has already set a preference
      const savedLanguage = localStorage.getItem('preferred_language');

      if (savedLanguage) {

        changeLanguage(savedLanguage);
        return;
      }

      // Auto-detect location for first-time users
      try {

        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 5000);
        const response = await fetch('https://ipapi.co/json/', { signal: controller.signal });
        clearTimeout(timeoutId);
        const data = await response.json();

        if (data.country_code) {
          const state = data.region;
          const country = data.country_code;



          // Only auto-translate for Indian users
          if (country === 'IN') {
            const detectedLang = detectLanguageFromState(state);


            if (detectedLang !== 'en') {
              changeLanguage(detectedLang);
            }
          }
        }
      } catch (error) {

      }
    };

    // Wait for Google Translate to be ready, then auto-translate
    const checkAndTranslate = (attempts = 0) => {
      const maxAttempts = 20;
      const dropdown = document.querySelector('.goog-te-combo');

      if (dropdown) {

        autoTranslate();
      } else if (attempts < maxAttempts) {
        setTimeout(() => checkAndTranslate(attempts + 1), 500);
      } else {

      }
    };

    checkAndTranslate();
  }, []);

  const changeLanguage = (langCode) => {
    const select = document.querySelector('.goog-te-combo');
    if (select && select.value !== langCode) {
      select.value = langCode;
      select.dispatchEvent(new Event('change'));
      localStorage.setItem('preferred_language', langCode);
    }
  };

  const detectLanguageFromState = (state) => {
    const stateMap = {
      // Hindi-speaking states
      'Delhi': 'hi',
      'Uttar Pradesh': 'hi',
      'Madhya Pradesh': 'hi',
      'Rajasthan': 'hi',
      'Bihar': 'hi',
      'Jharkhand': 'hi',
      'Uttarakhand': 'hi',
      'Haryana': 'hi',
      'Himachal Pradesh': 'hi',
      'Chhattisgarh': 'hi',

      // Regional languages
      'Maharashtra': 'mr',
      'Tamil Nadu': 'ta',
      'Telangana': 'te',
      'Andhra Pradesh': 'te',
      'West Bengal': 'bn',
      'Gujarat': 'gu',
      'Karnataka': 'kn',
      'Kerala': 'ml',
      'Punjab': 'pa',
      'Odisha': 'or',
      'Assam': 'as',
      'Jammu and Kashmir': 'ur',
      'Sikkim': 'ne',
    };

    return stateMap[state] || 'hi'; // Default to Hindi for India
  };

  return null; // This component doesn't render anything
};

export default IndianAutoTranslate;
